import AgentLoginEvent from './AgentLoginEvent';
import AgentNotifyEvent from './AgentNotifyEvent';
import BrokerSuccessEvent from './BrokerSuccessEvent';
import NewWhatsAppEvent from './NewWhatsAppEvent';
import NewWhatsAppMessageEvent from './NewWhatsAppMessageEvent';
import PingBrokerEvent from './PingBrokerEvent';
import WhatsAppTransferEvent from './WhatsAppTransferEvent';
import NewChatvisorEvent from './NewChatvisorEvent';
import NewChatvisorMessageEvent from './NewChatvisorMessageEvent';
import EndChatvisorEvent from './EndChatvisorEvent';
import PingChatvisorBrokerEvent from './PingChatvisorBrokerEvent';
import WhatsAppOnHoldEvent from './WhatsAppOnHoldEvent';
import StatusWhatsAppMessageEvent from './StatusWhatsAppMessageEvent';
import AgentLogoffForcedEvent from './AgentLogoffForcedEvent';
import RemoveWhatsAppInboxEvent from './RemoveWhatsAppInboxEvent';
import NewWhatsAppInboxEvent from './NewWhatsAppInboxEvent';
import AgentStopListenerQueueEvent from './AgentStopListenerQueueEvent';
import WhatsAppOpenInboxEvent from './WhatsAppOpenInboxEvent';
import NumberDontHasWhatsappEvent from './NumberDontHasWhatsappEvent';
import BrokerErrorEvent from './BrokerErrorEvent';
import RemoveWhatsAppEvent from './RemoveWhatsAppEvent';
import voiceEvents from './voice';
import pauseEvents from './pause';
import channelEvents from './channel';
import chatEvents from './chat';
import ManualWhatsAppRequestEvent from './ManualWhatsAppRequestEvent';
import RefreshOrgUnitEvent from './RefreshOrgUnitEvent';
import BroadcastWhatsAppListQueuedEvent from './broadcast/BroadcastWhatsAppListQueuedEvent';
import BroadcastWhatsAppListStartedEvent from './broadcast/BroadcastWhatsAppListStartedEvent';
import BroadcastWhatsAppListScheduleUpdateEvent from './broadcast/BroadcastWhatsAppListScheduleUpdateEvent';
import BroadcastWhatsAppListScheduleBulkUpdateEvent from './broadcast/BroadcastWhatsAppListScheduleBulkUpdateEvent';
import EmployerRefreshEvent from './_employer/EmployerRefreshEvent';
import RefreshAttendanceGroupDataEvent from './_attendanceGroup/RefreshAttendanceGroupDataEvent';
import InternalCallAnswerEvent from './colleagues/InternalCallAnswerEvent';
import InternalCallEndEvent from './colleagues/InternalCallEndEvent';
import NewInternalCallEvent from './colleagues/NewInternalCallEvent';
import InternalCallEvent from './colleagues/InternalCallEvent';
import InternalCallStatusEvent from './colleagues/InternalCallStatusEvent';
import EmailStatusEvent from '@/modules/email/infra/events/EmailStatusEvent.ts';
import WhatsAppTransferResponseEvent from './WhatsAppTransferResponseEvent';
import WhatsAppTransferInboxEvent from './WhatsAppTransferInboxEvent';
import QualifiedAttendanceEvent from './QualifiedAttendanceEvent';
import WhatsAppCallPermissionReplyEvent from './WhatsAppCallPermissionReplyEvent';
import AddedTagInAttendanceEvent from './AddedTagInAttendanceEvent';
import RemovedTagInAttendanceEvent from './RemovedTagInAttendanceEvent';

const map = {
  AgentLoginEvent,
  AgentNotifyEvent,
  NewWhatsAppEvent,
  NewWhatsAppMessageEvent,
  PingBrokerEvent,
  WhatsAppTransferEvent,
  NewChatvisorEvent,
  NewChatvisorMessageEvent,
  EndChatvisorEvent,
  PingChatvisorBrokerEvent,
  WhatsAppOnHoldEvent,
  StatusWhatsAppMessageEvent,
  AgentLogoffForcedEvent,
  RemoveWhatsAppInboxEvent,
  NewWhatsAppInboxEvent,
  AgentStopListenerQueueEvent,
  WhatsAppOpenInboxEvent,
  NumberDontHasWhatsappEvent,
  BrokerErrorEvent,
  RemoveWhatsAppEvent,
  ManualWhatsAppRequestEvent,
  BrokerSuccessEvent,
  RefreshOrgUnitEvent,
  BroadcastWhatsAppListQueuedEvent,
  BroadcastWhatsAppListScheduleUpdateEvent,
  BroadcastWhatsAppListScheduleBulkUpdateEvent,
  BroadcastWhatsAppListStartedEvent,
  EmployerRefreshEvent,
  RefreshAttendanceGroupDataEvent,
  InternalCallAnswerEvent,
  InternalCallEndEvent,
  NewInternalCallEvent,
  InternalCallEvent,
  InternalCallStatusEvent,
  EmailStatusEvent,
  WhatsAppTransferResponseEvent,
  WhatsAppTransferInboxEvent,
  QualifiedAttendanceEvent,
  WhatsAppCallPermissionReplyEvent,
  AddedTagInAttendanceEvent,
  RemovedTagInAttendanceEvent,
  ...voiceEvents,
  ...pauseEvents,
  ...channelEvents,
  ...chatEvents,
};

export default class CallEvent {
  constructor(event, body) {
    this._logEvent(event);
    if (map[event]) {
      return new map[event](body);
    }
    window.console.warn(`Evento não registrado - ${event}`, body);
  }

  _logEvent(event) {
    const blacklistEvents = ['PingBrokerEvent', 'PingChatvisorBrokerEvent'];
    const eventInBlacklist = blacklistEvents.indexOf(event) != -1;

    if (!eventInBlacklist) console.log('[event] ', event);
  }
}
